<template>
  <div class="cs-selectCourse-container">
    <div class="cs-selectCourse-filterContainer">
      <el-row
        v-if="courseType == 1"
        class="cs-selectCourse-filterItem"
      >
        <el-col :span="3">
          <span>学校:</span>
        </el-col>
        <el-col :span="8">
          <span>{{this.model.universityGroupText}}</span>
        </el-col>
        <el-col :span="1">
          &nbsp;
        </el-col>
        <el-col v-if="isStudyAbroad && dataIn.studyAbroadData" :span="3">
          <span>截止日期:</span>
        </el-col>
        <el-col v-if="isStudyAbroad && dataIn.studyAbroadData" :span="8">
          <span>{{this.dataIn.studyAbroadData.endDate}}</span>
        </el-col>
      </el-row>
      <el-row
        v-if="isStudyAbroad && dataIn.studyAbroadData"
        class="cs-selectCourse-filterItem"
      >
        <el-col :span="3">
          <span>业务:</span>
        </el-col>
        <el-col :span="8">
          <span>{{this.dataIn.studyAbroadData.serviceItemName}}</span>
        </el-col>
        <el-col :span="1">
          &nbsp;
        </el-col>
        <el-col :span="3">
          <span>剩余:</span>
        </el-col>
        <el-col :span="8">
          <span>{{this.quantityAvailable}}/{{this.dataIn.studyAbroadData.quantityTotal}}次</span>
        </el-col>
      </el-row>
      <el-row
        v-if="courseType == 2 || courseType == 3 || courseType == 4"
        class="cs-selectCourse-filterItem"
      >
        <el-col :span="3">
          <span>业务:</span>
        </el-col>
        <el-col :span="8">
          <el-select
            size="small"
            v-model="model.categoryId"
            @change="onCategoryChange"
            placeholder="请选择业务"
          >
            <el-option
              v-for="item in dataIn.categoryList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row
        v-if="courseType == 1 || courseType == 3"
        class="cs-selectCourse-filterItem"
      >
        <el-col :span="3">
          <span>学期:</span>
        </el-col>
        <el-col :span="8">
          <el-select
            size="small"
            v-model="model.termId"
            @change="onTermChange"
            placeholder="请选择学期"
          >
            <el-option
              v-for="term in termList"
              :key="term.Id"
              :label="term.DisplayLable"
              :value="term.Id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row
        v-if="courseType == 2 || courseType == 3 || courseType == 4"
        class="cs-selectCourse-filterItem"
      >
        <el-col :span="3">
          <span>校区:</span>
        </el-col>
        <el-col :span="8">
          <el-select
            size="small"
            v-model="model.campusId"
            @change="onCampusChange"
            placeholder="请选择校区"
          >
            <el-option
              v-for="item in campusList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <el-row class="cs-selectCourse-courseContainer">
      <el-col :span="24">
        <el-checkbox-group
          v-model="model.selectedCourseIdList"
          class="cs-selectCourse-courseList"
          @change="onCourseChange"
        >
          <el-checkbox
            class="cs-selectCourse-courseItem"
            v-for="item in courseList"
            :key="item.Id"
            :label="item.Id"
          >{{item.Name}}</el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-selectCourse-container {
  .cs-selectCourse-filterContainer {
    padding: 0 40px 10px 40px;

    .cs-selectCourse-filterItem {
      margin-top: 10px;
    }
  }
  .cs-selectCourse-courseContainer {
    background-color: #f5f7fa;
    margin-top: 5px;
    padding: 30px;

    .cs-selectCourse-courseList {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .cs-selectCourse-courseItem {
        flex: 1;
        margin-left: 0;
        width: 20%;
        min-width: 20%;
        max-width: 20%;
        //white-space: normal;
      }
    }
  }
}
</style>

<script>
import {
  getCurrentNextTerms,
  getCoursesWithTerm,
  getTrainingCourses
} from "../../../service/speedupCourse.service";

export default {
  props: {
    isStudyAbroad: Boolean,
    courseType: Number,
    dataIn: {
      universityGroups: Array,
      //termList: Array,
      campusList: Array,
      categoryList: Array,
      modelData: {
        universityGroupNumber: Number,
        universityGroupText: String,
        termId: Number,
        termText: String,
        categoryId: Number,
        campusId: Number | String,
        selectedCourseList: Array,
        selectedCourseIdList: Array
      },
      studyAbroadData: {
        workflowServiceItemId: Number,
        endDate: String,
        serviceItemName: String,
        quantityTotal: Number,
        quantityAvailable: Number
      },
    }
  },
  data() {
    return {
      campusList: [],
      courseList: [],
      termList:[],
      quantityAvailable: 0,
      model: {
        universityGroupNumber: 0,
        universityGroupText: "",
        termId: "",
        termText: "",
        categoryId: "",
        campusId: "",
        selectedCourseList: [],
        selectedCourseIdList: []
      }
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    onCourseChange() {
      this.getSelectedCourseList();
    },
    onUniversityChange() {
      this.loadCourseList(true);
    },
    onTermChange() {
      this.model.termText = this.getTermText(this.model.termId);
      this.loadCourseList(true);
    },
    async onCategoryChange() {
      await this.loadTermList();
      this.model.termId = this.termList[0].Id;
      this.model.termText = this.getTermText(this.model.termId);
      this.loadCourseList(true);
    },
    onCampusChange() {
      //this.loadCourseList(true);
    },
    getSelectedCourseList() {
      let list = [];

      this.model.selectedCourseIdList.forEach(element => {
        let course = this.courseList.filter(i => i.Id == element);
        if (course.length > 0) {
          list.push(course[0]);
        }
      });
      this.$set(this.model, "selectedCourseList", list);
    },
    async loadTermList(){
        let termType = 1;
        if (this.courseType == 3){
          termType = 2;
          if (!this.model.categoryId)
            return;
        }else if (this.courseType == 2){
          termType = 3;
        }else if (this.courseType == 4){
          termType = 4;
        }
        let result = await getCurrentNextTerms(termType, this.model.categoryId);
        if (!!result && result.success) {
          this.termList = result.data;
          this.resetTerm();
        }
    },
    loadCourseList(isReset) {
      if (isReset) {
        this.model.selectedCourseList = [];
        this.model.selectedCourseIdList = [];
      }
      if (this.courseType == 1) {
        if (
          !!this.model &&
          !!this.model.termId &&
          !!this.model.universityGroupNumber
        ) {
          getCoursesWithTerm(
            this.model.termId,
            this.model.universityGroupNumber,
            true
          ).then(result => {
            if (!!result && result.success) {
              this.courseList = result.data;
              this.getSelectedCourseList();
            }
          });
        }
      } else if (this.courseType == 2 || this.courseType == 3 || this.courseType == 4) {
        if (!!this.model && !!this.model.categoryId && (!!this.model.termId || this.courseType == 2 || this.courseType == 4)) {
          let termId = this.model.termId;
          if (this.courseType == 2 || this.courseType == 4){
            termId = 0;
          }
          getTrainingCourses(termId, this.model.categoryId).then(result => {
            if (!!result && result.success) {
              this.courseList = result.data;
              this.loadCampusList();
              this.getSelectedCourseList();
            }
          });
        }
      }
    },
    getTermText(termId) {
      let result = this.termList.filter(i => i.Id == termId);
      if (result.length > 0) {
        return result[0].DisplayLable;
      }
      return "";
    },
    loadCampusList(){
      if (this.courseType === 3 && this.dataIn.campusList && this.courseList){
        let campusIdList = [];
        let hasAll = false;
        for(let i = 0; i < this.courseList.length; i ++){
          let course = this.courseList[i];
          if (!course.CampusList || course.CampusList.length == 0){
            hasAll = true;
            break;
          }
          for(let j = 0; j < course.CampusList.length; j ++){
            let campusId = course.CampusList[j];
            if (campusIdList.indexOf(campusId) < 0){
              campusIdList.push(campusId);
            }
          }
        }

        if (!hasAll){
          let list = this.dataIn.campusList.filter(i => campusIdList.indexOf(i.Id) >= 0);
          if (list.length == 0){
            hasAll = true;
          }else{
            this.campusList = list;
            if (this.model.campusId){
              if (campusIdList.indexOf(this.model.campusId) < 0){
                this.model.campusId = this.campusList[0].Id;
              }
            }  
          }       
        }

        if (hasAll){
          this.campusList = this.dataIn.campusList;
        }
      }else{
        this.campusList = this.dataIn.campusList;
      }
    },
    async init() {
    
      if (!!this.dataIn && !!this.dataIn.modelData) {
        this.model = this.dataIn.modelData;
        await this.loadTermList();
        this.resetTerm();
        this.loadCourseList();
      }

      if (!!this.dataIn && !!this.dataIn.studyAbroadData){
        this.quantityAvailable = this.dataIn.studyAbroadData.quantityAvailable;
      }
    },
    resetTerm(){
      if (this.termList.length > 0){
        let reset = false;
        if (!this.model.termId){
          reset = true;
        }else{
          let index = this.termList.findIndex(i => i.Id === this.model.termId);
          if (index < 0){
            reset = true;
          }
        }

        if (reset){
          this.model.termId = this.termList[0].Id;
          this.model.termText = this.getTermText(this.model.termId);
        }
      }
    }
  },
  watch: {
    dataIn: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/selectCourse.vue